import { Table } from 'react-dsgov';
import { IArrematacaoListagemResumo } from '../../../../../../interfaces/IArrematacao';
import { BrLoading } from '@govbr-ds/react-components';
import styles from './arrematacaoTableResumo.module.scss';
import { formatCurrency } from '../../../../../../utils/formatCurrency';
import { formatarNrProcesso } from '../../../../../../utils/formatNrProcesso';
import { formatNumber, formatStringToBR } from '../../../../../../utils/formatNumber';

interface IProps {
  data: IArrematacaoListagemResumo[];
  isLoading: boolean;
}

const headers = [
  { field: 'codigoNCM', label: 'Código NCM' },
  { field: 'quantidade', label: 'Quantidade' },
  { field: 'precoUnitario', label: 'Preço Unitário' },
  { field: 'valor', label: 'Valor' },
];

export const ArrematacaoTableResumo = ({ data, isLoading }: IProps) => {
  return (
    <div className={styles.customTable}>
      {data.length === 0 && !isLoading ? (
        <Table headers={headers} showPagination={false} showDensityButtons={false} showSearch={false} density='medium'>
          <tbody className={styles.noRecords}>
            <tr>
              <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                Não há operações para serem exibidas.
              </td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <></> &&
        data.map((row, index) => (
          <div key={index} className={styles.container}>
            <div className={styles.tableTitle}>
              <i className={`fas fa-file fa-md  ${styles.columnIcon}`} />
              <div className={styles.tableContentContainer}>
                <div className={styles.tableContent}>
                  {row.numeroProcesso ? (
                    <>
                      <span>Processo Minerário: </span> <p>{formatarNrProcesso(row.numeroProcesso)}</p>
                    </>
                  ) : (
                    <span>Sem Processo Minerário</span>
                  )}
                </div>
                <div className={styles.tableContent}>
                  <span>Substância: </span> <p>{row.substancia}</p>
                </div>
                <div className={styles.tableContent}>
                  <span>Município/UF: </span> <p>{row.municipio ? `${row.municipio.nome}/${row.municipio.uf}` : ''}</p>
                </div>
              </div>
            </div>
            <Table
              showTopBar={false}
              headers={headers}
              showPagination={false}
              showDensityButtons={false}
              showSearch={false}
              density='medium'
              className={styles.arrematacaoTable}
            >
              <tbody>
                {row.arrematacao.componenteBaseDeCalculo.codigosNCM.map((codigoNCM, index) => (
                  <tr key={index}>
                    {headers.map((header) => {
                      if (header?.field === 'precoUnitario') {
                        if (codigoNCM['quantidade'] === '0')
                          return (
                            <td key={header.field} align='center'>
                              x
                            </td>
                          );

                        return (
                          <td align='center' key={header.field}>
                            {formatCurrency(
                              (parseFloat(codigoNCM['valor']) / parseFloat(codigoNCM['quantidade'])).toFixed(2)
                            )}
                          </td>
                        );
                      }
                      if (header?.field === 'valor')
                        return (
                          <td align='center' key={header.field}>
                            {formatCurrency(codigoNCM[header.field])}
                          </td>
                        );
                      if (header?.field === 'quantidade')
                        return (
                          <td align='center' key={header.field}>
                            {formatStringToBR(codigoNCM[header.field].toString())} {row.arrematacao.unidadeMedida}
                          </td>
                        );
                      if (header?.field === 'codigoNCM')
                        return (
                          <td align='center' key={header.field}>
                            {codigoNCM[header.field]}
                          </td>
                        );
                      return '';
                    })}
                  </tr>
                ))}
              </tbody>
              <tfoot className={styles.tableFooter}>
                <tr>
                  <th>Total</th>
                  <th>
                    {row.totais.quantidadeTotal.toString().replace('.', ',') + ' ' + row.arrematacao.unidadeMedida}{' '}
                  </th>
                  <th></th>
                  <th>{formatCurrency(row.totais.valorTotalDeOperacao)}</th>
                </tr>
              </tfoot>
            </Table>
            <div className={styles.observacoes}>
              <div className={styles.tableContent}>
                <span>Observações: </span>
                <p>{row.arrematacao?.observacoes?.trim() || '-'}</p>
              </div>
            </div>
          </div>
        ))
      )}
      {isLoading && (
        <div className={styles.tableLoading}>
          <BrLoading large label='Carregando...' />
        </div>
      )}
    </div>
  );
};
